import { Competition, GameRules } from "../types/competition";

export const WHS_LISTING_ID = "__whs_hi__";
export const WHS_LISTING_LABEL = "WHS Handicap Index";
export const WHS_LISTING_SHORT_LABEL = "WHS Index";
export const GAME_RULE_LISTING_ID = "__game_rule__";
export const GAME_RULE_LISTING_LABEL = "This rule";

export type HandicapListingKind = "game_rule" | "custom_rule" | "whs_hi";

export type HandicapListingOption = {
  id: string;
  label: string;
  kind: HandicapListingKind;
};

export function isWhsListingId(id?: string | null): boolean {
  return id === WHS_LISTING_ID || id === "whs_hi";
}

export function customRuleListingOptions(
  competitions: Competition[],
  excludeRuleId?: string,
): HandicapListingOption[] {
  return competitions
    .filter(c => c.type === GameRules.CUSTOM && c._id !== excludeRuleId)
    .map(c => ({
      id: c._id,
      label: c.name,
      kind: "custom_rule" as const,
    }));
}

export type HandicapListingDisplayEntry = {
  key: string;
  label: string;
  hcp: number | string;
  isWhsIndex?: boolean;
};

export function buildProfileHandicapListings(
  whsIndex: number | string | null | undefined,
  customHandicaps: { game: string; hcp: number; lastUpdateDate?: number; isWhsIndex?: boolean }[] = [],
): HandicapListingDisplayEntry[] {
  const entries: HandicapListingDisplayEntry[] = [];

  if (whsIndex !== null && whsIndex !== undefined && whsIndex !== "") {
    entries.push({
      key: WHS_LISTING_ID,
      label: WHS_LISTING_LABEL,
      hcp: whsIndex,
      isWhsIndex: true,
    });
  }

  customHandicaps
    .filter(h => !h.isWhsIndex && !isWhsListingId(h.game))
    .sort((a, b) => (b.lastUpdateDate || 0) - (a.lastUpdateDate || 0))
    .forEach(h => {
      entries.push({
        key: h.isWhsIndex ? WHS_LISTING_ID : `${h.game}-${h.lastUpdateDate ?? h.hcp}`,
        label: h.game,
        hcp: h.hcp,
        isWhsIndex: h.isWhsIndex,
      });
    });

  return entries;
}
